import HTMLEditor, {HTMLEditorProps} from 'lib/ui/form/HTMLEditor'
import {
  EMAIL,
  FIRST_NAME,
  LAST_NAME,
  LOGIN_URL,
  ORDER_TOTAL,
  TICKET_NAME,
} from 'lib/ui/form/HTMLEditor/variables'
import React from 'react'

export default function HtmlNotificationHTMLEditor(props: HTMLEditorProps) {
  return (
    <HTMLEditor
      toolbar={[
        'heading',
        'customFontSize',
        'fontColor',
        'fontBackgroundColor',
        'alignment',
        'bold',
        'italic',
        'strikethrough',
        'superscript',
        'removeFormat',
        'link',
        'imageUpload',
        'bulletedList',
        'numberedList',
        'outdent',
        'indent',
        'obvioVariable',
        'insertCustomButton',
        'customTheme',
      ]}
      variables={[
        LOGIN_URL,
        FIRST_NAME,
        LAST_NAME,
        EMAIL,
        TICKET_NAME,
        ORDER_TOTAL,
      ]}
      {...props}
    />
  )
}
